import { useEffect } from "react";
import { useHistory, useParams } from "react-router";
import { useTranslation } from "react-i18next";
import WithFab from "../../../hoc/with-fab";
import WithNavigation from "../../../hoc/with-navigation";
import { home } from "ionicons/icons";
import TvmForm from "../../../components/common/tvm-form";
import { useSystem } from "../../../store/system";
import { TvmFormSubmitResult } from "../../../components/common/tvm-form/form-definition";
import TrawlSystemResults from "../../../components/trawl-system-results";

import "./styles.css";


const FORM_ID = "tangonero";

interface TangonesResult {
	TangonesResult: any;
}

const Tangones = () => {
	const { systemId } = useParams<any>();
	const history = useHistory();

	const systemStore = useSystem();

	const { t } = useTranslation();

	const updateResults = (data: TvmFormSubmitResult<TangonesResult>) => {
		systemStore.submitFormResult(systemId, FORM_ID, data);
	};

	useEffect(() => {
		systemStore.loadForm(FORM_ID);
		systemStore.loadFormResult(systemId, FORM_ID);

		return () => {
			systemStore.reset();
		};
	}, []);

	return (
		<>
			<WithNavigation
				hintsContent={{
					title: systemStore.currentForm?.hints.title,
					htmlDef: systemStore.currentForm?.hints.htmlDef,
				}}
				preventGoBack={false}
				text={t("system.trawlSystems.title")}
			>
				<div className="form">
					{systemStore.currentForm && (
						<>
							{systemStore.formResultReqInfo?.finished && (
								<TvmForm
									title={t("system.trawlSystems.tangones.title")}
									systemName={systemId}
									topImage="/assets/tangoneros.png"
									definition={systemStore.currentForm}
									fieldValues={systemStore.currentFormValues}
									onSubmit={updateResults}
								/>
							)}
							{systemStore.formResult && (
								<TrawlSystemResults results={systemStore.formResult} />
							)}
						</>
					)}
				</div>
			</WithNavigation>
		</>
	);
};

export default Tangones;
